// 帳票出力モジュール
// 全 8 種類の帳票を 2 カテゴリ(発注者提出 / 運用管理)で提供。

import type { ExtendedDB } from "../../../../types/extendedDB";
import { exportQualityControlReport } from "./qualityControlReport";
import { exportPaintRecord } from "./paintRecord";
import { exportTraceabilityByMaterial } from "./traceabilityByMaterial";
import { exportQualityList } from "./qualityListReport";
import { exportMaterialDeliveryTable } from "./materialDeliveryTable";
import { exportMaterialLedger } from "./materialLedger";
import { exportMaterialExpirationTable } from "./materialExpirationTable";
import { exportMaterialInspectionReport } from "./materialInspectionReport";

export type ReportCategory = "submission" | "operation";

export type ReportDef = {
  key: string;
  name: string;
  desc: string;
  category: ReportCategory;
  sampleRef?: string;
  exporter: (db: ExtendedDB, workId?: number) => Promise<void>;
};

export const reports: ReportDef[] = [
  // ===== 発注者提出系 =====
  {
    key: "qc",
    name: "品質管理報告書",
    desc: "温度・湿度・含水率・膜厚の測定一覧と規格値(3シート + 工事ヘッダ)",
    category: "submission",
    sampleRef: "品質管理報告書.pdf",
    exporter: exportQualityControlReport,
  },
  {
    key: "paint",
    name: "塗装工事記録表",
    desc: "概要表 + 施工箇所別シート(工種×種別×場所スロット単位、4工程の動的展開)",
    category: "submission",
    sampleRef: "塗装工事記録表.pdf",
    exporter: exportPaintRecord,
  },
  {
    key: "trace_m",
    name: "トレーサビリティ情報一覧",
    desc: "QR 1個ごとに発行〜出荷〜搬入〜施工〜消費 を横一行で記載(46列、区分1〜10すべて)",
    category: "submission",
    sampleRef: "トレーサビリティ情報一覧.pdf",
    exporter: exportTraceabilityByMaterial,
  },
  {
    key: "ql",
    name: "品質管理一覧表",
    desc: "工程実施毎に温湿度・配合比・撹拌時間・可使時間と合否判定(ヘッダ部に合否判定利用値)",
    category: "submission",
    sampleRef: "品質管理一覧表.pdf",
    exporter: exportQualityList,
  },
  // ===== 運用管理系 =====
  {
    key: "delivery",
    name: "材料搬入表 (NEXCO対応)",
    desc: "行=材料、列=搬入回(日付)のマトリクス。各セルに LotNo / 製造日 / 管理番号(範囲) / 搬入合計",
    category: "operation",
    sampleRef: "材料搬入表(NEXCO対応).pdf",
    exporter: exportMaterialDeliveryTable,
  },
  {
    key: "ledger",
    name: "材料管理(受払簿)",
    desc: "材料ごとの納入・払出(消費)・残数を時系列で。サマリシート + 材料別シート",
    category: "operation",
    sampleRef: "既存システム「材料管理」相当",
    exporter: exportMaterialLedger,
  },
  {
    key: "expiry",
    name: "材料使用期限管理表",
    desc: "在庫中の材料を残日数昇順で表示。期限60日以内=黄色、期限切れ=赤色で警告",
    category: "operation",
    sampleRef: "既存システム「材料使用期限管理表」相当",
    exporter: exportMaterialExpirationTable,
  },
  {
    key: "inspection",
    name: "工事材料検査報告書",
    desc: "搬入時の検査記録(温湿度・受領者・立会・検査結果)の集約",
    category: "operation",
    sampleRef: "既存システム「工事材料検査報告書」相当",
    exporter: exportMaterialInspectionReport,
  },
];

export {
  exportQualityControlReport,
  exportPaintRecord,
  exportTraceabilityByMaterial,
  exportQualityList,
  exportMaterialDeliveryTable,
  exportMaterialLedger,
  exportMaterialExpirationTable,
  exportMaterialInspectionReport,
};
